<h2 mat-dialog-title class="mc-vert-tb modal-title">{{ header }}</h2>

<mat-dialog-content>
	<div class="col-12">
		<div class="container mt-2" id="printable">
			<div class="row justify-content-center">
				<ng-container *ngIf="QRimgSrc; else loadingQR">
					<img class="QRimgSrc" src="{{ QRimgSrc }}" />
				</ng-container>
				<ng-template #loadingQR>
					<div class="QRimgSrc"
						style="width:280px;height:280px;background:#f5f5f5;border-radius:8px; display: flex; justify-content: center; align-items: center;">
						<mat-spinner diameter="64"></mat-spinner>
					</div>
				</ng-template>
				<div #userQRCont class="col-12 align-self-center text-center qr-class" id="userQR"></div>
			</div>
		</div>
	</div>
	<mat-dialog-actions align="center">
		<div class="row buttons-row">
			<button mat-mini-fab color="clear" (click)="printQR()">
				<mat-icon>print</mat-icon>
			</button>

			<button mat-mini-fab #imprimir (click)="downloadQR()" color="clear" [disabled]="spinnerDownload">
				<mat-icon *ngIf="!spinnerDownload">download</mat-icon>
				<mat-spinner *ngIf="spinnerDownload" diameter="24"></mat-spinner>
			</button>
		</div>
	</mat-dialog-actions>
</mat-dialog-content>